import C3Chart from 'react-c3js';
import React from 'react';
import styles from './styles';
import TransformIcon from '@material-ui/icons/Transform';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import icons from '../../../utils/icons';

const generateStageProgress = (stages, statistics) => ({
  data: {
    columns: stages.map((stage) => {
      return [stage.name, statistics[stage.id] ? (statistics[stage.id].complete * 100) / statistics[stage.id].total : 0];
    }),
    type: 'gauge',
  },
  gauge: {},
  color: {
    pattern: ['#FF0000', '#F97600', '#F6C600', '#60B044'], // the three color levels for the percentage values.
    threshold: {
      values: [30, 60, 90, 100],
    },
  },
  size: {
    height: 180,
  },
});

// const generateStageProgress = (name, statistics) => {
//   console.log('statistics', statistics)
//   const progress = statistics ? (statistics.complete * 100) / statistics.total : 0;
//   return generateProgress(name, progress);
// };

const renderNoData = () => {
  return (<div style={styles.noDataRow}>
    <TransformIcon style={styles.noData}/>
    <div>No tasks are available</div>
  </div>);
};

class StageProgressGaugeChart extends React.Component {
  state = {
    stageIdx: 0,
  }

  renderStageNavigationItem = (stage) => (<BottomNavigationAction
    key={stage.id}
    label={stage.name}
    icon={<div style={{ textAlign: 'center', }}>
      <img
        alt="Stage"
        className="material-icons"
        src={icons[stage.icon]}
        style={styles.stageIcon}/>
    </div>}
  />);

  render() {
    const { statistics, stages } = this.props;
    const { stageIdx } = this.state;

    console.log('renderStageProgressChart', stages);
    if (!stages) {
      return renderNoData();
    }

    console.log('stages', stages);
    console.log('stageIdx', stageIdx);
    const stage = stages[stageIdx];

    console.log('statistics', statistics);
    const stageProgressChart = generateStageProgress(stages, statistics);

    console.log('stageProgressChart', stageProgressChart);
    return (<div>
      <C3Chart data={stageProgressChart.data} color={stageProgressChart.color} size={{ height: 250 }}/>
      {/*<BottomNavigation*/}
        {/*value={this.state.selectedStageIndex}*/}
        {/*onChange={(evt, stageIdx) => this.setState({ stageIdx })}*/}
        {/*showLabels*/}
      {/*>*/}
        {/*{stages.map(this.renderStageNavigationItem)}*/}
      {/*</BottomNavigation>*/}
    </div>);

  }
}

export default StageProgressGaugeChart;



// WEBPACK FOOTER //
// ./src/components/Reports/JobReport/StageProgressGaugeChart.js